import MainProductSlider from './MainProductSlider'

export default MainProductSlider
